export enum SurveySummaryStateEnum {
  IS_GETTING = 'isGetting',
  ERROR = 'error',
  SURVEY_SUMMARIES = 'summaries'
}
